import Axios from 'axios'
import config from '@/config/config.js'

const baseUrl = config.apiDomain.ALI + '/ext/ps/ps/'
// const staffUrl = baseUrl + 'staff'
const appraiserUrl = baseUrl + 'getAppraiser'

Axios.defaults.headers.timeout = 8000

export default {

  getAppraiser (cb) {
    return new Promise((resolve, reject) => {
      Axios.get(appraiserUrl).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
          reject(error.response)
        }
      )
    })
  },

  getEvaluatedStaffByAppraiser (cb) {
    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + 'getEvaluatedStaffByAppraiser').then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.error(error)
          reject(error.response)
        }
      )
    })
  }
}
